import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Specialist extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Specialist';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'specialist', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'board-member',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/specialists/' + this.id;
    }
}
